import React, { Component } from 'react';
import { View, TouchableOpacity, Image, Text } from 'react-native';
import Toast from 'react-native-easy-toast';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withMaybe } from '../../lib/Monads';
import withNavigation from '../../utils/WithNavigation';
const JSONAPIDeserializer = require('jsonapi-serializer').Deserializer;
import {
  LAYOUT,
  THEME,
  MAX_LINES,
  CURRENCY_SYMBOL,
  REMOTE_CONFIG_KEYS,
} from '../../config/Constants';
import ProductCardStyles from './styles/styles';
import { PRODUCT } from '../../config/LayoutConstants/ProductConfig';
import Utility from '../../utils/Utility';
import AddToCart from './AddToCart';
import { ProductInCartStyles } from './styles';
import images from '../../theme/Images';
import {
  removeFromCart,
  cancelOrderItemById,
  isSpecialOfferApplied,
} from '../../actions/ActionTypes';
import colors from '../../theme/Colors';
import FoxyAlert from '../camera/shared/FoxyAlert';
import {
  EventParameterKey,
  AnalyticsManager,
  EventType,
} from '../../analytics';
import RemoteConfig from '../../utils/RemoteConfig';
import FullWidthShimmer from '../../lib/FullWidthShimmer';
import FastImageView from '../FastImageView';
import { getMinifiedImage } from '../../utils/ImageUtility';

class RoutineCardForCart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAlert: false,
      alertText: '',
      alertWhatsAppMessage: '',
      showFlashDealTimer: true,
      routineData: {},
    };
    const {
      cartItem: { routine = {} },
    } = props;
    try {
      new JSONAPIDeserializer({
        typeAsAttribute: false,
        pluralizeType: true,
        keyForAttribute: 'camelCase',
      })
        .deserialize(routine)
        .then((data) => {
          this.setState({
            routineData: data,
          });
        });
    } catch (e) {}
    this.routineMeta = {};
    this.debouncedNavigate = _.debounce(this.navigate, 1000, {
      leading: true,
      trailing: false,
    });
  }

  componentDidMount() {
    const { cartItem } = this.props;

    const offerActive = RemoteConfig.getValue(REMOTE_CONFIG_KEYS.active_offer);

    if (Utility.isPresent(cartItem)) {
      this.routineMeta = this.getRoutineMeta();
    }
    if (cartItem.offer_id === offerActive) {
      isSpecialOfferApplied(cartItem.eligible_for_free_item);
    }
  }

  componentDidUpdate(prevProps) {
    const { cartItem, isSpecialOfferApplied } = this.props;
    if (Utility.isPresent(cartItem) && Utility.isPresent(cartItem.offer_id)) {
      if (
        prevProps.cartItem.eligible_for_free_item !==
        cartItem.eligible_for_free_item
      ) {
        isSpecialOfferApplied(cartItem.eligible_for_free_item);
      }
    }
  }

  setShowFlashDealTimer = (show) => {
    this.setState({
      showFlashDealTimer: show,
    });
  };

  navigate = () => {
    const { navigation, id, onPress = () => {} } = this.props;
    const { routineData } = this.state;
    onPress();
    navigation.push('PreRoutineDetails', {
      id,
      // itemData,
      slug: routineData.slug,
      display: LAYOUT.SCREEN,
      sku_id: routineData.skuId,
      previousScreen: this.props?.previousScreen,
    });
  };

  navigatefromOrders = () => {
    const { navigation } = this.props;
    const { routineData } = this.state;
    navigation.navigate('PreRoutineDetails', {
      slug: routineData.slug,
      sku_id: routineData.skuIid,
      display: LAYOUT.SCREEN,
    });
  };

  navigateToOrderDetail = () => {
    const { navigation, orderId } = this.props;
    navigation.navigate('OrderDetails', { id: orderId });
  };

  showDiscountRateConditionFn = (props) =>
    props.discount === null || props.discount === '';

  discountConditionFn = (props) =>
    parseFloat(props.sp) === parseFloat(props.mrp);

  conditionalPriceText = withMaybe(this.discountConditionFn)(Text);

  conditionalDiscountText = withMaybe(this.showDiscountRateConditionFn)(Text);

  getRoutineMeta = () => {
    const { routineData } = this.state;
    const {
      cartItem: { final_mrp = '', final_sp = '', quantity = '' },
    } = this.props;

    const productMeta = {
      [EventParameterKey.PRODUCT_ID]: routineData.id,
      [EventParameterKey.PRODUCT_NAME]: routineData.name,
      [EventParameterKey.PRODUCT_LISTING_PRICE]: final_mrp,
      [EventParameterKey.PRODUCT_SELLING_PRICE]: final_sp,
      [EventParameterKey.QUANTITY]: quantity,
    };
    return productMeta;
  };

  removeProductFromCart = () => {
    const {
      skuId,
      refreshOfferStrip,
      refreshOffersDetailsPageDiscountStrip,
      onItemAddToCartFromCollab,
      campaignId,
    } = this.props;
    const data = {
      sku_id: skuId,
    };
    this.props.removeFromCart(data, () => {
      if (onItemAddToCartFromCollab) {
        if (Utility.isPresent(campaignId)) onItemAddToCartFromCollab();
      }
    });
    if (refreshOfferStrip) {
      setTimeout(() => {
        refreshOfferStrip();
        if (refreshOffersDetailsPageDiscountStrip) {
          refreshOffersDetailsPageDiscountStrip();
        }
      }, 200);
    }
    AnalyticsManager.logEvent(
      EventType.discoveryEvents.PRODUCT_REMOVE_FROM_CART,
      this.routineMeta,
    );
  };

  fireStockErrorAnalytics = () => {
    AnalyticsManager.logEvent(EventType.product.STOCK_ERROR, this.productMeta);
  };

  RatingComponent = (props) => {
    const { layout, rating } = props;
    const styles = ProductCardStyles;
    return (
      <View
        style={[styles.ratingRectangle, styles[`${layout}RatingRectangle`]]}
      >
        <Text numberOfLines={MAX_LINES.single} style={styles.ratingnumber}>
          {rating}
        </Text>
      </View>
    );
  };

  productImageAndRating = (props) => {
    const { imageUrl, opacity } = props;
    const styles = ProductInCartStyles;
    const newImageUrl = getMinifiedImage(
      imageUrl,
      styles.productImage.width,
      styles.productImage.height,
    );
    return (
      <>
        <FastImageView
          resizeMode="contain"
          source={newImageUrl}
          style={[styles.productImage, { opacity }]}
        />
      </>
    );
  };

  productImage = (props) => {
    const { imageUrl, fromOrderDetail, inOrderDetail } = props;
    const styles = ProductInCartStyles;
    return (
      <TouchableOpacity
        onPress={
          fromOrderDetail || inOrderDetail
            ? this.navigatefromOrders
            : this.navigateToOrderDetail
        }
      >
        <Image
          source={{
            uri: getMinifiedImage(
              imageUrl,
              styles.productImageOrders.width,
              styles.productImageOrders.height,
            ),
          }}
          style={styles.productImageOrders}
        />
      </TouchableOpacity>
    );
  };

  descriptionForFreeProduct = (props) => {
    const styles = ProductInCartStyles;
    const { shouldShowStrikedPriceForFreeItem, mrp } = props;

    return (
      <View style={styles.priceContainer}>
        <Text style={[styles.spStyle, { color: colors.green }]}>FREE</Text>
        {parseFloat(mrp) !== 0 && (
          <Text style={[styles.mrpStyle, { marginRight: 4 }]}>
            {`${CURRENCY_SYMBOL}${mrp}`}
          </Text>
        )}
      </View>
    );
  };

  productDescription = (props) => {
    const styles = ProductInCartStyles;
    const { couponCodes, hideAddToCart } = this.props;
    const {
      mrp = '',
      sp = '',
      discount = '',
      brandName = 'Foxy',
      name = '',
      isFree,
      couponDiscount,
      participating_discount_offer_id,
    } = props;
    let { prompt_discount = '', prompt_esp = '', prompt_mrp = '' } = props;
    const productName = name.replace(`${brandName} `, '');
    const shouldShowStrikedPriceForFreeItem =
      isFree && Utility.isPresent(couponDiscount) && couponDiscount !== 0;
    if (Utility.isPresent(prompt_esp)) {
      sp = prompt_esp;
      mrp = prompt_mrp;
      discount = prompt_discount;
    }

    const participating_discount_offer = _.find(
      couponCodes,
      (code) => code.offer_id === participating_discount_offer_id,
    );

    const productDescriptionStyleInCart = hideAddToCart
      ? styles.descriptionContainerStyleWithoutAddToCart
      : styles.descriptionContainerStyleWithAddToCart;

    const discountedPrice = sp === 0 ? `FREE` : `${CURRENCY_SYMBOL}${sp} `;

    return (
      <View style={productDescriptionStyleInCart}>
        <Text numberOfLines={MAX_LINES.single} style={styles.brandName}>
          {brandName?.toUpperCase()}
        </Text>
        <Text numberOfLines={MAX_LINES.two} style={styles.productName}>
          {productName}
        </Text>
        {isFree ? (
          <this.descriptionForFreeProduct
            shouldShowStrikedPriceForFreeItem={
              shouldShowStrikedPriceForFreeItem
            }
            mrp={mrp}
          />
        ) : (
          <View style={styles.priceContainer}>
            {Utility.isPresent(sp) && (
              <Text style={styles.spStyle}>{discountedPrice}</Text>
            )}
            {Utility.isPresent(mrp) && (
              <this.conditionalPriceText
                style={styles.mrpStyle}
                sp={sp}
                mrp={mrp}
              >
                {`${CURRENCY_SYMBOL}${mrp}`}
              </this.conditionalPriceText>
            )}
            {parseFloat(sp) !== parseFloat(mrp) && (
              <this.conditionalDiscountText
                style={styles.discountRateStyle}
                discount={discount}
              >
                {` ${discount || ''}`}
              </this.conditionalDiscountText>
            )}
          </View>
        )}
        {Utility.isPresent(participating_discount_offer) && (
          <View style={styles.productCardCouponContainer}>
            <Image
              source={images.ic_coupon}
              style={styles.productCardCouponImage}
            />
            <Text
              style={styles.couponAppliedStyle}
            >{`${participating_discount_offer?.coupon_code} applied`}</Text>
          </View>
        )}
      </View>
    );
  };

  cancelAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  cancelOrderItem = (id) => {
    const { cancelOrderItemById } = this.props;
    cancelOrderItemById(id, (response) => {
      if (response === 'success') {
        this.setState({ showAlert: false });
      }
    });
  };

  addToCartError = (response) => {
    const { showToastInCart = () => {} } = this.props;
    if (Utility.isPresent(response.errors) && response.errors.length > 0) {
      showToastInCart(response.errors[0]);
      this.fireStockErrorAnalytics();
    }
  };

  orderStatusRow = (props) => {
    const { item } = props;

    let isDeliveryDateVisible =
      Utility.isBlank(item.formatted_expected_delivery_date) ||
      item.status !== 'cancelled';

    let deliveryDate = '';
    if (item.status === 'delivered' || item.status === 'closed') {
      deliveryDate = `Delivered on: ${item.formatted_actual_delivery_date}`;
    } else if (
      item.status === 'cancelled' ||
      Utility.isBlank(item.formatted_expected_delivery_date)
    ) {
      deliveryDate = '';
    } else {
      deliveryDate = `Expected Delivery By: ${item.formatted_expected_delivery_date}`;
    }
    return (
      <View style={ProductCardStyles.row}>
        <Text style={[ProductCardStyles.orderStatus, { color: colors.green }]}>
          {Utility.getOrderStatusText(Utility.getShipmentStatus(item.status))}
        </Text>

        {isDeliveryDateVisible && (
          <Text
            style={[ProductCardStyles.orderStatus, { color: colors.silver }]}
          >
            {deliveryDate}
          </Text>
        )}
      </View>
    );
  };

  decideNavigation = () => {
    const {
      addToCart,
      fromOrderDetail,
      cartProduct: { type = '', slug = '', sku_id = '' } = {},
      navigation,
    } = this.props;
    const { cartItem } = this.props;
    if (type === 'routine') {
      navigation.navigate('PreRoutineDetails', {
        slug: slug,
        sku_id: sku_id,
      });
      return;
    }

    if (addToCart) {
      this.debouncedNavigate();
    } else if (cartItem.fromOrderDetail) {
      this.navigatefromOrders();
    } else if (!fromOrderDetail) {
      this.navigateToOrderDetail();
    }
  };

  oosProductMessage = () => {
    return (
      <View
        style={{
          position: 'absolute',
          bottom: '40%',
          left: 12,
          backgroundColor: colors.white,
          padding: 4,
          borderRadius: 2,
        }}
      >
        <Text
          style={{
            fontFamily: 'Roboto-Regular',
            fontSize: 12,

            fontStyle: 'normal',
            letterSpacing: 0,
            color: colors.foxyPink,
          }}
        >
          Out of stock
        </Text>
      </View>
    );
  };

  viewFreeProductScreen = () => {
    const { navigation } = this.props;
    AnalyticsManager.logEvent('change_free_product', {
      screen: 'cart',
    });
    navigation.push('FreeProductScreen');
  };

  render() {
    const { orientation, theme = THEME.LIGHT, previousScreen } = this.props;

    const {
      layout,
      size,
      skuId,
      quantity,
      addedToCart,
      addToCart,
      fromOrderDetail,
      showOrderStatus,
      error,
      refreshOfferStrip,
      maxFreeItemsToSelect,
      showToast,
      refreshOffersDetailsPageDiscountStrip,
      campaignId,
      onItemAddToCartFromCollab,
      couponCodes,
      hideAddToCart = false,
      isDigitalSku,
      todayDealss: { ends_at, skus = [] } = {},
      cartProduct: { type = '' } = {},
      listData = {},
      cartItem,
    } = this.props;
    const { routineData } = this.state;

    if (Utility.isBlank(skuId) && addToCart) {
      if (Utility.isBlank(cartItem)) {
        return null;
      }
    }
    const { showAlert, alertText, showFlashDealTimer } = this.state;
    const styles = ProductInCartStyles;
    let color = colors.white;

    const clubDealTag = Utility.jsonParser(
      RemoteConfig.getValue(REMOTE_CONFIG_KEYS.club_member),
      'club_member_ProductCartForCart',
    )?.tag;

    let opacity = 1;
    if (Utility.isPresent(error)) {
      opacity = 0.4;
      color = '#fafafa';
    }

    const mrp = cartItem.final_mrp;
    const sp = cartItem.final_sp;
    const discount = cartItem.final_discount;

    const disableItemPress = hideAddToCart || isDigitalSku;

    return (
      <>
        <TouchableOpacity
          onPress={this.decideNavigation}
          disabled={disableItemPress}
        >
          <View style={[styles.cardStyleForCart, { backgroundColor: color }]}>
            {addToCart && (
              <this.productImageAndRating
                imageUrl={routineData.cardImageUrl}
                layout={layout}
                size={size}
                id={routineData.id}
                opacity={opacity}
              />
            )}
            {!addToCart && (
              <this.productImage
                imageUrl={routineData.cardImageUrl}
                layout={layout}
                size={size}
                id={routineData.id}
                fromOrderDetail={cartItem.fromOrderDetail}
                inOrderDetail={cartItem.inOrderDetail}
              />
            )}

            {addToCart && (
              <this.productDescription
                mrp={mrp}
                name={routineData.name}
                sp={sp}
                discount={discount}
                orderStatus={cartItem.orderStatus}
                expectedDeliveryDate={cartItem.expectedDeliveryDate}
                isFree={cartItem.is_free}
                opacity={opacity}
                couponDiscount={discount}
                participating_discount_offer_id={
                  cartItem.participating_discount_offer_id
                }
              />
            )}
            {addToCart && !hideAddToCart && (
              <AddToCart
                skuId={skuId}
                quantity={quantity}
                orientation={orientation}
                layout={layout}
                theme={theme}
                addToCartLayout={PRODUCT.ADD_TO_CART_LAYOUT.CART}
                cartItem={cartItem.routine}
                variant={cartItem.variant}
                error={error}
                errorCallback={this.addToCartError}
                refreshOfferStrip={refreshOfferStrip}
                previousScreen={previousScreen}
                maxFreeItemsToSelect={maxFreeItemsToSelect}
                showToast={showToast}
                refreshOffersDetailsPageDiscountStrip={
                  refreshOffersDetailsPageDiscountStrip
                }
                campaignId={campaignId}
                onItemAddToCartFromCollab={onItemAddToCartFromCollab}
                isFree={!!cartItem.is_free}
                disableQuantityChange={cartItem.disable_quantity_change}
                isFreeItem={!!cartItem.is_free_item}
                isFreeProduct={!!cartItem.is_free_product}
                setPromptLoading={this.props.setPromptLoading}
                isPrompStopLoading={this.props.isPrompStopLoading}
                type={type}
                listData={listData}
                restrictAddToCart
              />
            )}
            <FoxyAlert
              isVisible={showAlert}
              alertBoxTitle="Cancel this product?"
              alertMessage={alertText}
              firstButtonTitle="Yes"
              firstButtonTextColor={colors.dodgerBluePressed}
              secondButtonTitle="No"
              firstButtonOnPress={() => this.cancelOrderItem(routineData.id)}
              secondButtonOnPress={this.cancelAlert}
              showWhatsappHyperlink
              whatsappHyperlinkMessage={this.state.alertWhatsAppMessage}
              height={250}
            />
          </View>

          {/* FIXME: This is not a proper way to do it. You should either
                    ask for this from service or it should be a part of component's property.
                    @Aman needs to fix it.
           */}
          {this.state.showFlashDealTimer &&
            Utility.isPresent(skus[`${skuId}`]) &&
            (participating_discount_offer_type === 'flash_deal' ||
              participating_discount_offer_type === 'club_deal') && (
              <>
                <FastImageView
                  source={images.label.uri}
                  style={styles.flashDealImage}
                />
                <View style={styles.flashDealContainer}>
                  <Text style={styles.flashDealText}>
                    {participating_discount_offer_type === 'flash_deal'
                      ? 'Flash deal'
                      : clubDealTag}
                  </Text>
                  <FullWidthShimmer style={styles.shimmer} speed={2000} />
                </View>
              </>
            )}
          {showOrderStatus && <this.orderStatusRow item={cartItem} />}
          {Utility.isPresent(error) && <this.oosProductMessage />}
        </TouchableOpacity>
        <Toast
          ref={(ref) => {
            this.toast = ref;
          }}
        />
      </>
    );
  }
}

RoutineCardForCart.defaultProps = {
  addToCart: true,
  fromOrderDetail: false,
  inOrderDetail: false,
};

const mapStateToProps = (store, ownProps) => {
  const { id } = ownProps;
  return {
    addedToCart: !!(store.bag && store.bag.cartItems[id]),
    configs: store.UserAccountInfo.remote_configs,
    userCreatedAt: store.UserAccountInfo.app_installed_at,
    todayDealss: store.todayDeals,
    couponCodes:
      store.bag.cartPricing && store.bag.cartPricing.coupon_codes
        ? store.bag.cartPricing.coupon_codes
        : [],
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    { removeFromCart, cancelOrderItemById, isSpecialOfferApplied },
    dispatch,
  ),
});

export default withNavigation(
  connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
    RoutineCardForCart,
  ),
);
